export default "__VITE_ASSET__ExFOTY5b__"